/**
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="testimonials-carousel"></div>
 */

 import 'slick-carousel';

 $( function() {
     $( '[data-component="p2-faculty-banner-slider"]' ).each( function() {
         let $holder = $( this );
         $holder.slick(
             {
                // rows: 1,
                speed: 5000,
                pauseOnHover: false,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                infinite: true,
                arrows: false,
                variableWidth: true,
            
              }
         );
     } );
 } );
 